import React, { useState, useEffect } from 'react';

function Countdown({ onComplete }) {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count <= 0) return;
    const timer = setTimeout(() => setCount(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [count]);

  useEffect(() => {
    if (count === 0) {
      const timer = setTimeout(() => onComplete?.(), 90);
      return () => clearTimeout(timer);
    }
  }, [count, onComplete]);

  return (
    <div className="dashboard">
      <div className="home__center startup__stack">
        <span className="secretpin__title">
          {count > 0 ? `${count}...` : ''}
        </span>
      </div>
    </div>
  );
}

export default Countdown;
